<template>
  <div class="page-wrapper">
    <div class="main">
      <h2 class="news-title">{{detail.title}}</h2>
      <div class="infos"><span>{{detail.category}}</span><span>{{detail.displayTime || detail.createTime.slice(0,10)}}</span></div>
      <div class="rich-text" v-html="detail.subject"></div>
    </div>
    
  </div>
</template>

<script>
import { utils } from '@/common/common.js'
import { ajaxNews } from '@/common/request_news.js'

export default {
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  inject: ["reload"],
  data() {
    return {
      detail: {
        title: '',
        category: '',
        createTime: '',
        subject: '',
        displayTime: ''
      }
    };
  },
  watch: {},
  created() {
    this.getDetail();
    // this.uploadFileApi = api.baseUrl + '/file/uploadfilebatch';
  },
  methods: {
    getDetail() {
        ajaxNews.get('/api/news/detail', {id: this.$route.query.id}).then(res=> {
            console.log(res)
						this.detail = res.data
        }).catch(err=> {
            console.log(err)
        })
    },
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 32px 16px;
  margin: 0 16px 16px;
  background: #fff;
  .main {
    margin: 0 auto;
    width: 750px;
    padding: 24px 50px;
    border: 1px solid #e5e5e5;
  }
  .news-title {
      margin: 0;
      padding: 24px 0;
      font-size: 36px;
  }
  .infos {
    margin-bottom: 24px;
    font-size: 14px;
    color: #666;
    span {
      margin-right: 16px;
    }
  }
  .rich-text {
    font-size: 16px;
    line-height: 2;
    >>>  p {margin-bottom: 1em;}
    >>> img {max-width: 100%;}
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/news/detail.vue